export const getStrikeThroughStyles = (hasStrikeThrough?: boolean) => {
  if (hasStrikeThrough) {
    return {
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 'calc(50% - 1px)',
        left: 0,
        height: '1px',
        width: '100%',
        bg: 'currentColor',
      },
    };
  }

  return {};
};
